import type { ServerPlayers } from "@/api";
import { isPlayerSnapshot } from "./player-snapshot-fence";

const PLAYER_FRESHNESS_MS = 20_000;

/** Delivery never replaces the source timestamp, including repeated socket events. */
export function playersAreStale(players: ServerPlayers | null, now = Date.now()): boolean {
  if (!isPlayerSnapshot(players) || players.stale || !players.capturedAt) {
    return true;
  }
  const age = now - Date.parse(players.capturedAt);
  return !Number.isFinite(age) || age < 0 || age > PLAYER_FRESHNESS_MS;
}
